function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: CHECKFIELD opcode — compare a resolved field value to a scalar or value list.
 *
 * Language shape:
 *   script.field     — value path / literal
 *   script.operator  — "==" | "!=" | "<" | ... | "IN" | "NOT"
 *   script.value     — scalar (== / != / ordering) OR array of candidates (IN / NOT)
 *
 * IN  → field value equals at least one list element
 * NOT → field value equals none of the list elements
 */

module.exports = {
  name: 'CHECKFIELD',
  description: "\nCompares a resolved field value using a comparison operator.\n\n== / equals     \u2192 equals scalar\n!= / notequals  \u2192 not equal scalar\n< <= > >=       \u2192 ordering (when both sides are comparable)\nIN              \u2192 value equals at least one list element\nNOT             \u2192 value equals none of the list elements\n",
  exampleScript: {
    op: 'CHECKFIELD',
    field: 'db.type',
    operator: 'IN',
    value: ['UPDATE', 'CREATE']
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    var operator = node.operator;
    if (typeof operator !== 'string' || operator.length === 0) {
      return false;
    }
    var left = resolveRef(context, node.field);
    if (left === undefined || left === null) {
      return false;
    }
    if (operator === 'IN' || operator === 'NOT') {
      var list = node.value;
      if (typeof list === 'string') {
        list = resolveRef(context, list);
      }
      if (!Array.isArray(list)) {
        return false;
      }
      var matched = false;
      for (var i = 0; i < list.length; i += 1) {
        var candidate = resolveRef(context, list[i]);
        if (typeof candidate === 'string' && Object.prototype.hasOwnProperty.call(context, candidate)) {
          candidate = context[candidate];
        }
        if (valuesEqual(left, candidate)) {
          matched = true;
          break;
        }
      }
      if (operator === 'IN') {
        return matched === true;
      }
      return matched === false;
    }
    var right = resolveRef(context, node.value);
    if (typeof right === 'string' && Object.prototype.hasOwnProperty.call(context, right)) {
      right = context[right];
    }
    if (right === undefined) {
      return false;
    }
    var lnum = Number(left);
    var rnum = Number(right);
    var l = Number.isFinite(lnum) ? lnum : left;
    var r = Number.isFinite(rnum) ? rnum : right;
    if (operator === '==' || operator === 'equals') {
      return l === r;
    }
    if (operator === '!=' || operator === 'notequals') {
      return l !== r;
    }
    if (operator === '<' || operator === 'lessthan') {
      return l < r;
    }
    if (operator === '<=' || operator === 'lessthanorequal') {
      return l <= r;
    }
    if (operator === '>' || operator === 'greaterthan') {
      return l > r;
    }
    if (operator === '>=' || operator === 'greaterthanorequal') {
      return l >= r;
    }
    return false;
  }
};
function valuesEqual(left, right) {
  if (left === undefined || left === null || right === undefined || right === null) {
    return false;
  }
  if (typeof left === 'number' && Number.isFinite(left)) {
    return typeof right === 'number' && Number.isFinite(right) && left === right;
  }
  if (typeof left === 'string') {
    return typeof right === 'string' && left === right;
  }
  if (typeof left === 'boolean') {
    return typeof right === 'boolean' && left === right;
  }
  return false;
}
function resolveRef(root, ref) {
  if (typeof ref !== 'string') {
    return ref;
  }
  var parts = ref.split('.');
  var cursor = root;
  for (var i = 0; i < parts.length; i += 1) {
    var key = parts[i];
    if (!cursor || _typeof(cursor) !== 'object' || !Object.prototype.hasOwnProperty.call(cursor, key)) {
      return ref;
    }
    cursor = cursor[key];
  }
  return cursor;
}